import { _ as _extends } from './extends-3e8335ef.esm.js';
import React__default, { useState, useEffect } from 'react';
import { Animated, View, StyleSheet } from 'react-native';
import { u as useTheme } from './useTheme-c05a5bd5.esm.js';

const AppSpinner = _ref => {
  let {
    backgroundColor,
    duration = 400,
    iterations = -1,
    outputRange = ["0deg", "380deg"],
    size = 50,
    startColor,
    endColor,
    containerStyle
  } = _ref;
  const [rotateValue, setRotateValue] = useState(new Animated.Value(0));
  const {
    currentTheme
  } = useTheme();
  const _styles = styleGenerator({
    currentTheme,
    backgroundColor
  });
  useEffect(() => {
    _start();
  }, []);
  const _start = () => {
    Animated.loop(Animated.timing(rotateValue, {
      duration,
      toValue: 1,
      useNativeDriver: false
    }), {
      iterations
    }).start();
  };
  return /*#__PURE__*/React__default.createElement(View, {
    style: [_styles.container, containerStyle]
  }, /*#__PURE__*/React__default.createElement(Animated.View, {
    style: {
      transform: [{
        rotate: rotateValue.interpolate({
          inputRange: [0, 1],
          outputRange
        })
      }],
      height: size,
      width: size,
      margin: 5,
      borderWidth: 2,
      borderColor: startColor || currentTheme?.theme?.grey,
      borderBottomColor: endColor || currentTheme?.theme?.primary,
      borderRadius: size,
      justifyContent: "center"
    }
  }), /*#__PURE__*/React__default.createElement(Animated.View, null));
};
const styleGenerator = _ref2 => {
  let {
    currentTheme,
    backgroundColor
  } = _ref2;
  return StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: backgroundColor || currentTheme?.theme?.backgroundColor,
      alignItems: "center",
      justifyContent: "center"
    }
  });
};
AppSpinner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppSpinner",
  "props": {
    "duration": {
      "defaultValue": {
        "value": "400",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "It defines how long each loop should take"
    },
    "iterations": {
      "defaultValue": {
        "value": "-1",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "Defauled to -1 to produce the infinite spin effect, it declares the number of spins performed by the component before stopping"
    },
    "outputRange": {
      "defaultValue": {
        "value": "[\"0deg\", \"380deg\"]",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "Array",
        "elements": [{
          "name": "string"
        }],
        "raw": "string[]"
      },
      "description": "When passed, it changes the key degrees in which the animation briefly stops"
    },
    "size": {
      "defaultValue": {
        "value": "50",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": "When passed it changes the size of the spinner"
    },
    "backgroundColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Changes the background color of the spinner"
    },
    "containerStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style to apply to container of the spinner"
    },
    "startColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "When passed it changes the color used at the start of the animation"
    },
    "endColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "When passed it changes the color used at the end of the animation"
    }
  }
};

const AppActivityIndicator = _ref => {
  let {
    visible = false,
    backgroundColor,
    containerStyle,
    size,
    ...props
  } = _ref;
  if (!visible) return null;
  return /*#__PURE__*/React__default.createElement(AppSpinner, _extends({}, props, {
    size: size,
    containerStyle: containerStyle,
    backgroundColor: backgroundColor || "rgba(0,0,0,0)"
  }));
};
AppActivityIndicator.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppActivityIndicator",
  "props": {
    "visible": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true the component becomes visible"
    },
    "backgroundColor": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Defines the background color of the view containing the loading item"
    },
    "containerStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style to apply to the overall container of the component"
    },
    "size": {
      "required": false,
      "tsType": {
        "name": "number"
      },
      "description": ""
    }
  }
};

export { AppActivityIndicator as A, AppSpinner as a };
